





















































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component } from 'vue-property-decorator';
import RecaptchaComponent from '@/shared/captchaComponent/RecaptchaComponent.vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import { PageTitleConfig } from '@/shared/msw-app-title/type';
import UUIFComponents from '@/shared/uuifComponent';
import { SwTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import ApiServiceWrapper from '@/shared/api-request.service';

@Component({
  components: {
    ...UUIFComponents,
    RecaptchaComponent,
    MswAppTitle,
    SwTextfield,
    SwRadio,
  },
})
export default class SwForgotUsername extends SwExtendedVue {
  selectedOption: string = '';
  serialNumber: string = '';
  activationKey: string = '';
  emails: string[] = ['', '', ''];
  submitted: boolean = false;

  goBack() {
    this.$router.back();
  }

  getPayload(): object | null {
    const store = (this as any).$store;
    const t = (this as any).$t.bind(this);
    if (this.selectedOption === 'serial') {
      if (!this.serialNumber.trim()) {
        store.commit('enqueueMessage', { infoType: 'failed', infoMsg: t('forgotusername.serialNumberRequired').toString() });
        return null;
      }
      return { searchType: 'SN', searchValue: this.serialNumber.trim() };
    }
    if (this.selectedOption === 'activation') {
      if (!this.activationKey.trim()) {
        store.commit('enqueueMessage', { infoType: 'failed', infoMsg: t('forgotusername.actKeyRequired').toString() });
        return null;
      }
      return { searchType: 'AK', searchValue: this.activationKey.trim() };
    }
    if (this.selectedOption === 'emails') {
      const firstEmail = this.emails[0].trim();
      if (!firstEmail) {
        store.commit('enqueueMessage', { infoType: 'failed', infoMsg: t('forgotusername.emailAddressRequired').toString() });
        return null;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(firstEmail)) {
        store.commit('enqueueMessage', { infoType: 'failed', infoMsg: t('forgotusername.emailAddressInvalid').toString() });
        return null;
      }
      const filled = this.emails.map(e => e.trim()).filter(Boolean);
      return { searchType: 'EM', searchValue: filled.join(',') };
    }
    store.commit('enqueueMessage', { infoType: 'failed', infoMsg: t('forgotusername.requiredFieldValidator').toString() });
    return null;
  }

  submit() {
    const payload = this.getPayload();
    if (!payload) { return; }

    const captchaResult = (this.$refs.recaptchaRef as RecaptchaComponent).fetchCaptcha();
    if (captchaResult.status === 'error') {
      (this as any).$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: captchaResult.msg });
      return;
    }

    const store = (this as any).$store;
    const t = (this as any).$t.bind(this);
    const fallbackMsg = t('forgotusername.APIFailure').toString();
    const searchType = (payload as any).searchType;
    const searchValue = (payload as any).searchValue;
    const sourceName = window.btoa(`${searchValue}#${new Date().toLocaleDateString().replace(/[^ -~]/g, '')}#${captchaResult.response}`);
    const url = `users/forgot-username?inputValue=${encodeURIComponent(searchValue)}&searchType=${encodeURIComponent(searchType)}&captchaText=${encodeURIComponent(captchaResult.response)}&sourceName=${encodeURIComponent(sourceName)}&mode=workspace`;
    store.commit('startLoading');
    ApiServiceWrapper.get(url)
      .then((res: any) => {
        store.commit('stopLoading');
        if (res != null && res.operationStatus === 'OK') {
          this.submitted = true;
        } else {
          store.commit('enqueueMessage', { infoType: 'failed', infoMsg: (res != null ? res.msgDesc : null) || fallbackMsg });
        }
      })
      .catch((err: any) => {
        store.commit('stopLoading');
        const status = err && err.response && err.response.status;
        let errMsg: string;
        switch (status) {
          case 401: errMsg = t('systemMessages.err401').toString(); break;
          case 404: errMsg = t('systemMessages.err404').toString(); break;
          case 408: errMsg = t('systemMessages.err408').toString(); break;
          default:  errMsg = t('systemMessages.server').toString(); break;
        }
        store.commit('enqueueMessage', { infoType: 'failed', infoMsg: errMsg });
      });
  }

  get getHeaderConfig(): PageTitleConfig {
    return {
      pageTitle: this.$t('login.forgotUsernameTitle').toString(),
      pageParentName: '',
      isFetchFromProps: true,
      isShowDashboardIcon: false,
      isShowSlash: false,
      isShowParent: false,
    };
  }
}
